import { Navigate } from "react-router";

/**
 * SignupPage - Disabled for existing installations.
 *
 * Since the app is already initialized with users, the signup page
 * is no longer needed. Redirect any visitors to the login page.
 */
export const SignupPage = () => {
  return <Navigate to="/login" replace />;
};

SignupPage.path = "/sign-up";
